import { readSearchClient } from '../index';
import { getIndex } from './get-index';

export const getSettings = (key: string) => {
  const index = readSearchClient.initIndex(getIndex(key));
  return index.getSettings();
};
